import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Common } from './common/common';
import { CommonService } from './common/common.service';
import { JilabaAesED } from './common/JilabaAesED';
import { JilabaKeyEnum } from './common/JilabaKeyEnum';
import { ReturnStatus } from './common/returnstatus';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {

  title = 'ngcontactus';

  names: string = "";
  mobileno: string = "";
  emailid: string = "";
  subject: string = "";
  message: string = "";
  jewllery: string = "";
  area: string = "";


  homeurl:string="";
  aboutusurl:string="";
  productsurl:string="";
  careersurl:string="";
  sturegurl:string="";
  ticketurl:string="";
  contactusurl:string="";
  vendorportalurl:string="";
  aptitudeurl:string="";
  paymentlurl:string="";

  constructor(public snackbar: MatSnackBar,
    private commonService:CommonService) {
    Common.generateSnackBar(this.snackbar);
  }

  ngOnInit(): void {
    Common.url = (<HTMLInputElement>document.getElementById('serviceurl')).value;
    
    this.homeurl=(<HTMLInputElement>document.getElementById('homeurl')).value;
    this.aboutusurl=(<HTMLInputElement>document.getElementById('aboutusurl')).value;
    this.productsurl=(<HTMLInputElement>document.getElementById('productsurl')).value;
    this.careersurl=(<HTMLInputElement>document.getElementById('careersurl')).value;
    this.sturegurl=(<HTMLInputElement>document.getElementById('sturegurl')).value;
    this.ticketurl=(<HTMLInputElement>document.getElementById('ticketurl')).value;
    this.contactusurl=(<HTMLInputElement>document.getElementById('contactusurl')).value;
    this.vendorportalurl=(<HTMLInputElement>document.getElementById('vendorportalurl')).value;
    this.aptitudeurl=(<HTMLInputElement>document.getElementById('aptitudeurl')).value;
    this.paymentlurl=(<HTMLInputElement>document.getElementById('paymentlurl')).value;
  }

  async submitdata() {

    let returnstatus = new ReturnStatus();

    if (!this.names) {
      Common.openSnackBar('Enter Your Name', 'close');
      return;
    }

    if (!this.mobileno) {
      Common.openSnackBar('Enter Your Mobile No', 'close');
      return;
    }

    // if (!this.emailid){
    //   Common.openSnackBar('Enter Your MailId','close');
    //   return;
    // }

    if (this.emailid) {
      returnstatus = Common.mailValidation(this.emailid);
      if (!returnstatus.status) {
        Common.openSnackBar(returnstatus.description, 'close');
        return;
      }
    }

    // if (!this.subject){
    //   Common.openSnackBar('Enter Subject','close');
    //   return;
    // }

    // if (!this.message){
    //   Common.openSnackBar('Enter Your Message','close');
    //   return;
    // }

    this.jewllery=this.jewllery?this.jewllery:"";
    this.area=this.area?this.area:"";
    
    let map: any = {
      "name": this.names,
      "mobileno": this.mobileno,
      "email": this.emailid,
      "subject": this.subject,
      "message": this.message,
      "jewllery": this.jewllery,
      "area": this.area,
      "token": JilabaAesED.Encrypt(this.names, JilabaKeyEnum.CommonKey) 
      + JilabaAesED.Encrypt(this.mobileno, JilabaKeyEnum.CommonKey) 
      + JilabaAesED.Encrypt(this.emailid, JilabaKeyEnum.CommonKey) 
      + JilabaAesED.Encrypt(this.subject, JilabaKeyEnum.CommonKey) 
      + JilabaAesED.Encrypt(this.message, JilabaKeyEnum.CommonKey)
      + JilabaAesED.Encrypt(this.jewllery, JilabaKeyEnum.CommonKey)
      + JilabaAesED.Encrypt(this.area, JilabaKeyEnum.CommonKey)
    }

    await this.commonService.sendMail(map).then((data)=>{

      returnstatus=data;
      if(!returnstatus.status){
        Common.openSnackBar(returnstatus.description,'close');
        return;
      }

      Common.openSnackBar('Successfully Submited','close');
      this.clear()
    },err=>{
      Common.openSnackBar('Error in Submition','close');
    });
    ;

  }

  clear() {
    this.names = "";
    this.mobileno = "";
    this.emailid = "";
    this.subject = "";
    this.message = "";
    this.jewllery="";
    this.area="";
  }

}
